import * as React from "react";

import { Checkbox, FormControlLabel, FormGroup, styled, TextField } from "@mui/material";
import { UseFormRegister, FormState } from "react-hook-form/dist/types";

const Row = styled("div")(() => ({
  marginBottom: "20px",
  display: "flex",
  justifyContent: "space-between",
}));

interface TemplateConfigProps {
  register: UseFormRegister<any>;
  formState: FormState<any>;
  saveTemplate: boolean;
  setSaveTemplate: React.Dispatch<React.SetStateAction<boolean>>;
  saveDisk: boolean;
  setSaveDisk: React.Dispatch<React.SetStateAction<boolean>>;
}

export const TemplateConfig: React.FC<TemplateConfigProps> = ({
  register,
  formState,
  saveTemplate,
  setSaveTemplate,
  saveDisk,
  setSaveDisk,
}) => {
  const handleSaveChange = () => {
    setSaveTemplate(!saveTemplate);
  };

  const handleSaveDiskChange = () => {
    setSaveDisk(!saveDisk);
  };

  return (
    <>
      <Row>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={saveTemplate}
                id="save-template"
                data-testid="save-template"
                {...register("saveTemplate", {
                  onChange: () => {
                    handleSaveChange();
                  },
                })}
              />
            }
            label="Save Configuration as Template"
            sx={{ mr: 0 }}
          />
        </FormGroup>
      </Row>
      {saveTemplate && (
        <>
          <Row>
            <TextField
              fullWidth
              variant="outlined"
              id="template-name"
              inputProps={{
                "data-testid": "template-name",
              }}
              label="Template Name *"
              helperText={formState.errors?.templateName?.message || "Please specify a Template Name"}
              {...register("templateName")}
              error={!!formState?.errors?.templateName}
            />
          </Row>
          <Row>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={saveDisk}
                    id="save-disk"
                    data-testid="save-disk"
                    {...register("saveDisk", {
                      onChange: () => {
                        handleSaveDiskChange();
                      },
                    })}
                  />
                }
                label="Save Disk with Configuration"
                sx={{ mr: 0 }}
              />
            </FormGroup>
          </Row>
        </>
      )}
    </>
  );
};
